module.exports = __webpack_public_path__ + "img/ICONE-AGENDA2.79006b76.svg";